import { render, staticRenderFns } from "./feedback-modal.component.vue?vue&type=template&id=ed6df112&scoped=true"
import script from "./feedback-modal.component.vue?vue&type=script&lang=ts"
export * from "./feedback-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./feedback-modal.component.vue?vue&type=style&index=0&id=ed6df112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6df112",
  null
  
)

export default component.exports